export default "__VITE_ASSET__rPqakE4P__"